import React, { FC } from "react";
import hospitalisationImg from "assets/icons/hb.svg";
import otherImg from "assets/icons/ob.svg";

import { areAllObjectsKeysNull } from "utils/utils";
import { BenefitSummaryMobileTabsSkeleton, BenefitSummaryTabsSkeletonWeb } from "../../components/Skeleton/BenefitTab";

interface BenefitsTabsProps {
  activeTab: string;
  setActiveTab: any;
  benefitSumList: any;
}

const BenefitsTabs: FC<BenefitsTabsProps> = ({ activeTab, setActiveTab, benefitSumList }) => {
  const benefitSummaryTabs: { webName: string; icon: any; id: string }[] = [
    { webName: "Coverages", icon: hospitalisationImg, id: "coverages" },
    { webName: "Add-on Coverages", icon: otherImg, id: "addOns" }
  ];

  return (
    <div className="relative w-full">
      {/* Web View */}
      {benefitSumList ? (
        <div className={`hidden xl:flex justify-center gap-4 lg:gap-24  text-xs lg:text-sm font-bold `}>
          {benefitSummaryTabs.map((obj, i) => {
            if (areAllObjectsKeysNull(benefitSumList[obj.id])) return;
            return (
              <div key={i} onClick={() => setActiveTab(obj.id)} className={`tab cursor-pointer py-4 flex flex-col items-center transition-all duration-300 ${activeTab === obj.id && "border-b-2 border-black"}`}>
                <div className="flex items-center gap-2 z-10">
                  <img src={obj.icon} alt={obj.webName} />
                  <span>{obj.webName}</span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <BenefitSummaryTabsSkeletonWeb />
      )}

      {/* Mob View */}
      {benefitSumList ? (
        <div className="flex xl:hidden justify-center w-full text-xs font-bold overflow-x-auto scrollbar-hide items-center gap-2">
          {benefitSummaryTabs.map((obj, i) => {
            if (areAllObjectsKeysNull(benefitSumList[obj.id])) return;
            return (
              <div key={i} onClick={() => setActiveTab(obj.id)} className="w-full cursor-pointer py-4 flex items-center justify-center transition-all duration-300">
                <div className={`z-10 flex flex-col gap-2 items-center w-full justify-center text-center ${activeTab === obj.id ? "border-b-2 border-black pt-2" : ""}`}>
                  <img src={obj.icon} alt={obj.webName} className="h-6 object-contain" />
                  <span className="mb-2">{obj.webName}</span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <BenefitSummaryMobileTabsSkeleton />
      )}
    </div>
  );
};

export default BenefitsTabs;
